// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  window.gtag("event", "purchase", {
    send_to: ["AW-476095007/LX-yCKSAu-4BEJ_EguMB"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze",
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}


// ----------------- Begin Checkout SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after purchase
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  window.gtag("event", "begin_checkout", {
    send_to: ["AW-476095007/cIsiCK2Au-4BEJ_EguMB"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze",
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}